__turbopack_context__.v({
  "actions": "AddInsolePair-module__ZISG-a__actions",
  "container": "AddInsolePair-module__ZISG-a__container",
  "empty": "AddInsolePair-module__ZISG-a__empty",
  "field": "AddInsolePair-module__ZISG-a__field",
  "label": "AddInsolePair-module__ZISG-a__label",
  "modelImage": "AddInsolePair-module__ZISG-a__modelImage",
  "modelName": "AddInsolePair-module__ZISG-a__modelName",
  "modelPreview": "AddInsolePair-module__ZISG-a__modelPreview",
  "modelTile": "AddInsolePair-module__ZISG-a__modelTile",
  "modelTileSelected": "AddInsolePair-module__ZISG-a__modelTileSelected",
  "models": "AddInsolePair-module__ZISG-a__models",
});
